import { render, staticRenderFns } from "./NotifJoinRequestResponse.vue?vue&type=template&id=5a61ab94&scoped=true"
import script from "./NotifJoinRequestResponse.vue?vue&type=script&lang=js"
export * from "./NotifJoinRequestResponse.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=5a61ab94&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61ab94",
  null
  
)

export default component.exports